
import { BiltyFormat3 } from "BiltyFomates";
import { getPartyLrReport, getSupplerReportApi, getSupplerReportApi2 } from "_services";
import { CommonModal, CustomSelect } from "components";
import { API, AppConfig } from "lib";
import React, { useEffect, useState } from "react";
import moment from "moment";
import StorageService from "utils/StorageServices/StorageServices";
import { Images } from "constants";
import { StorageServices } from "utils";

const PartyLrReport = (props) => {
    const { consignor_id, start_date, end_date, closeModal } = props;
    const [loadingBilty, setLoadingBilty] = useState(false)
    let isToken = localStorage.getItem("token");
    const [buityFormatePreview, setBuityFormatePreview] = useState('')
    const [isLoaddingPrint, setIsLoaddingPrint] = useState(false)
    const companyId = StorageServices.getCompanyId()

    useEffect(() => {
        if (companyId && consignor_id && end_date && start_date) {
            getPartyLrReportData()
        }
    }, [companyId, consignor_id, end_date, start_date])

    const getPartyLrReportData = async () => {
        setLoadingBilty(true)
        try {
            const res = await getPartyLrReport({
                company_id: StorageService?.getCompanyId(),
                consignor_id: consignor_id,
                start_date: start_date,
                end_date: end_date
            });
            setBuityFormatePreview(res)
            if (res?.responseCode == 404) {
                setLoadingBilty(false)
                 closeModal()
            } else {
                 setLoadingBilty(false)
            }
        } catch (error) {
        }
    };

    const handleDownload = async () => {
        try {
            const payload = {
                company_id: StorageService?.getCompanyId(),
                consignor_id: consignor_id,
                start_date: start_date,
                end_date: end_date
            }
            setIsLoaddingPrint(true)
            const response = await fetch(`${AppConfig.api_baseurl}${API.PARTY_LR_REPORT_DOWNLOAD}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Party-LR-Report/${moment(new Date()).format("D MMM YYYY")}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setIsLoaddingPrint(false)
        } catch (error) {
            setIsLoaddingPrint(false)
        }
    }

    const formatePrpsTrip = {
        buityFormatePreview: buityFormatePreview
    };

    const propsBuiltyPrint = {
        ...props,
        onSubmit: handleDownload,
        isLoadding: isLoaddingPrint,
        disabled: isLoaddingPrint,
        isLoaddingPrint: isLoaddingPrint
    };

    return (
        <>
            <CommonModal {...propsBuiltyPrint}>
                <div className="bltyPrint_body" style={{ display: "block" }}>
                    <div className="bltyPrt_viewPage_bx" id="print-area">

                        {!loadingBilty ? <BiltyFormat3 {...formatePrpsTrip} /> : <div colSpan="100%" style={{ textAlign: "center", margin: "0 22rem", display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
                            <img className="_loadWidth" style={{ width: "150px", color: "f2f2f2" }} src={Images.LOADINGTRUCK} alt="" />
                        </div>}
                    </div>
                </div>
            </CommonModal>
        </>
    );
};

export default PartyLrReport;
